/*
 * @Autor: Nehc
 * @Date: 2020-12-03 11:20:04
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-03 11:20:18
 */
import Form from './form.vue';

export default Form;
